define("settings/utils/plan-score/index", ["exports", "settings/utils/plan-score/tables"], function (_exports, _tables) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.recommendPlan = recommendPlan;
  0; //eaimeta@70e063a35619d71f0,"settings/utils/plan-score/tables"eaimeta@70e063a35619d71f
  function maxTier() {
    for (var _len = arguments.length, tiers = new Array(_len), _key = 0; _key < _len; _key++) {
      tiers[_key] = arguments[_key];
    }
    return tiers.reduce((highest, tier) => {
      if (tier === undefined) {
        return highest;
      }
      return _tables.TIER_RANK[tier] > _tables.TIER_RANK[highest] ? tier : highest;
    }, 'starter');
  }

  /**
   * `final_tier = max(role_floor, base(points), goal_floor)`
   *
   * The three terms are computed independently and each can only push the tier up, never down.
   */
  function recommendPlan(answers) {
    const {
      role,
      profiles,
      goal
    } = answers;

    // With neither scale nor goal known the model skips the formula entirely and recommends
    // Growth flat. Load-bearing rather than defensive: for the floorless roles — and for no role
    // at all — the formula would give max(ø, ø, ø) -> Starter.
    if (profiles === undefined && goal === undefined) {
      return {
        tier: 'growth',
        planType: _tables.TIER_TO_PLAN_TYPE.growth,
        winningTerm: 'fallback'
      };
    }
    const goalFloor = goal === undefined ? undefined : _tables.GOAL_FLOOR[goal];
    const roleFloor = role === undefined ? undefined : _tables.ROLE_FLOOR[role];
    const basePoints = profiles === undefined ? undefined : _tables.BASE_TIER_BY_POINTS[_tables.PROFILE_POINTS[profiles]];

    // Spec: with Q2 skipped, base(points) defaults to Starter-level. It stays out of the
    // attribution below — a term contributing the lowest tier raised nothing.
    const tier = maxTier(goalFloor, roleFloor, basePoints ?? 'starter');
    const terms = {
      goal_floor: goalFloor,
      role_floor: roleFloor,
      base_points: basePoints
    };
    const winningTerm = _tables.TERM_PRECEDENCE.find(term => terms[term] === tier) ?? 'none';
    return {
      tier,
      planType: _tables.TIER_TO_PLAN_TYPE[tier],
      winningTerm
    };
  }
});